export const detectLocale = () => {
  let locale = ''
  if (typeof navigator !== 'undefined' && navigator.language) {
    locale = navigator.language.toLocaleLowerCase().substring(0, 2)
  }
  return locale || 'it'
}
